import { useMemo } from 'react';

export function useAuditClientFilter(
  data: any[],
  actorFilter: string,
  windFarmFilter: string,
): any[] {
  return useMemo(() => {
    let rows = data;
    if (actorFilter.trim()) {
      const q = actorFilter.trim().toLowerCase();
      rows = rows.filter((r) => r.actorName?.toLowerCase().includes(q));
    }
    if (windFarmFilter.trim()) {
      const q = windFarmFilter.trim().toLowerCase();
      rows = rows.filter((r) => r.pkValue?.toLowerCase().includes(q));
    }
    return rows;
  }, [data, actorFilter, windFarmFilter]);
}
